import ClientLayout from "../../layout/client/ClientLayout";
import HotelBooking from "../../view/client/bookings/HotelBooking";
import Dashboard from "../../view/client/Dashboard";
import RoomAvailability from "../../view/client/room-availability/RoomAvailability";
import ClientProtectedRoute from "./clientProtectedRoute";

const clientRoutes = {
  path: "/client",
  element: (
    <ClientProtectedRoute>
      <ClientLayout />
    </ClientProtectedRoute>
  ),
  children: [
    {
      path: "/client/dashboard",
      element: (
        <ClientProtectedRoute>
          <Dashboard />
        </ClientProtectedRoute>
      ),
    },
    {
      path: "/client/hotel/booking",
      element: (
        <ClientProtectedRoute>
          <HotelBooking />
        </ClientProtectedRoute>
      ),
    },
    {
      path: "/client/hotel/availability",
      element: (
        <ClientProtectedRoute>
          <RoomAvailability />
        </ClientProtectedRoute>
      ),
    },
  ],
};

export default clientRoutes;
